import httpAxios from "../js/request";
window.API = {
    getRegisterCaptcha: () => {
        return httpAxios.request({
            url: "/api/register/captcha",
            method: "GET",
            data: {},
        });
    },
    register: (data) => {
        return httpAxios.request({
            url: "/api/user/register",
            method: "POST",
            data,
        });
    },
    registerNPWPD: (data) => {
        return httpAxios.request({
            url: "/user/npwpd/register",
            method: "POST",
            data,
        });
    },
    logout: (data) => {
        return httpAxios.request({
            url: "/api/user/logout",
            method: "DELETE",
            data,
        });
    },
    getDataSPTPD: (data) => {
        return httpAxios.request({
            url: "/api/sptpd/data",
            method: "POST",
            data,
        });
    },
    getDataSKPDKB: (data) => {
        return httpAxios.request({
            url: "/api/skpdkb/data",
            method: "POST",
            data,
        });
    },
    getDataSSPD: (data) => {
        return httpAxios.request({
            url: "/api/sspd/data",
            method: "POST",
            data,
        });
    },

    getDataSSPDNoLapor: (data) => {
        return httpAxios.request({
            url: "/api/sspd/nolapor/data",
            method: "POST",
            data,
        });
    },

    getEmailOTP: (data) => {
        return httpAxios.request({
            url: "/api/otp/email",
            method: "POST",
            data,
        });
    },

    checkEmailOTP: (data) => {
        return httpAxios.request({
            url: "/api/otp/checkEmail",
            method: "POST",
            data,
        });
    },

    getWordTemplate: (data) => {
        return httpAxios.request({
            url: "/api/get/wordtemplate",
            method: "GET",
            data,
        });
    },

    checkNPWPD: (data) => {
        return httpAxios.request({
            url: "/api/check/npwpd",
            method: "POST",
            data,
        });
    },

    checkUsername: (data) => {
        return httpAxios.request({
            url: "/api/check/username",
            method: "POST",
            data,
        });
    },

    checkNIK: (data) => {
        return httpAxios.request({
            url: "/api/check/nik",
            method: "POST",
            data,
        });
    },

    getKecamatan: (data) => {
        return httpAxios.request({
            url: "/api/get/kecamatan",
            method: "GET",
            data,
        });
    },

    getKelurahan: (data) => {
        return httpAxios.request({
            url: "/api/get/kelurahan/" + data,
            method: "GET",
            data: {},
        });
    },

    getAllPajak: (data) => {
        return httpAxios.request({
            url: "/api/get/pajak",
            method: "GET",
            data,
        });
    },

    getBidangUsahaFromIdPajak: (data) => {
        return httpAxios.request({
            url: "/api/get/bidangusaha/" + data,
            method: "GET",
            data: {},
        });
    },

    getLastRealisasi: (data) => {
        return httpAxios.request({
            url: "/api/get/realisasi",
            method: "GET",
            data: data,
        });
    },
    getSubRealisasi: (data) => {
        return httpAxios.request({
            url: "/api/get/sub/realisasi",
            method: "POST",
            data,
        });
    },
    getDataPendaftaran: (data) => {
        return httpAxios.request({
            url: "/api/get/data/pendaftaran",
            method: "POST",
            data,
        });
    },
    getDataRealisasiPajak: (data) => {
        return httpAxios.request({
            url: "/api/get/realisasi/pajak",
            method: "POST",
            data,
        });
    },
    getPraSPTPD: (data) => {
        return httpAxios.request({
            url: "/api/sptpd/getPraSPTPD",
            method: "POST",
            data,
        });
    },
    getMasaPajakSPTPD: (data) => {
        return httpAxios.request({
            url: "/api/sptpd/getMasaPajak",
            method: "GET",
            data: {},
        });
    },
    getDataWP: (data) => {
        return httpAxios.request({
            url: "/api/get/data/wp",
            method: "GET",
            data: {},
        });
    },

    cekStatusAkun: (data) => {
        return httpAxios.request({
            url: "/cek/status/akun",
            method: "POST",
            data: data,
        });
    },

    getDaftarAntrian: () => {
        return httpAxios.request({
            url: "/user/get/antrian",
            method: "GET",
            data: {},
        });
    },

    getDaftarAntrianId: (id) => {
        return httpAxios.request({
            url: "/user/get/antrian/" + id,
            method: "GET",
            data: {},
        });
    },

    getFileAntrian: (data) => {
        return httpAxios.request({
            url: "/user/file/antrian",
            method: "GET",
            data: {},
        });
    },

    cekStatusAkunNPWPD: (data) => {
        return httpAxios.request({
            url: "/cek/status/npwpd",
            method: "POST",
            data: data,
        });
    },

    inputPengaduan: (data) => {
        return httpAxios.request({
            url: "/input/pengaduan",
            method: "POST",
            data: data,
        });
    },

    pbbSetNop: (data) => {
        return httpAxios.request({
            url: "/pbb/list",
            method: "POST",
            data: data,
        });
    },

    getListPBB: (data) => {
        return httpAxios.request({
            url: "/pbb/list?nop=" + data,
            method: "GET",
            data: {},
        });
    },

    getTagihanCount: () => {
        return httpAxios.request(
            {
                url: "api/tagihan/spt",
                method: "GET",
                data: {},
            },
            false
        );
    },

    getStatusAntrian: () => {
        return httpAxios.request(
            {
                url: "api/history/antrian",
                method: "GET",
                data: {},
            },
            false
        );
    },
};
